import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import GenerateGrantModal from './generate-grant';
import IconButton from 'components/common/IconButton';

const LivingCarbonGrant = () => {
  const [generateGrantModalVisible, setGenerateGrantModalVisible] =
    useState(false);

  const toggleModal = () => {
    setGenerateGrantModalVisible(prevVisible => !prevVisible);
  };
  return (
    <>
      <Card>
        <Card.Body>
          <div className="row align-items-center">
            <div className="col">
              <h5>My Planting Maps</h5>
            </div>
            <div className="col-auto">
              <div id="orders-actions">
                <IconButton
                  icon="plus"
                  transform="shrink-3"
                  className="me-2"
                  onClick={() => {
                    setGenerateGrantModalVisible(true);
                  }}
                >
                  <span className="d-none d-sm-inline-block ms-1">
                    Create a Planting Map
                  </span>
                </IconButton>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <GenerateGrantModal
        show={generateGrantModalVisible}
        onClose={toggleModal}
      ></GenerateGrantModal>
    </>
  );
};

export default LivingCarbonGrant;
